import Vue from 'vue';
import Router from 'vue-router';
import guessList from '@/components/guessList';
import mallIndex from '@/components/mallIndex';
import messageList from '@/components/messageList';
import exchangeRecord from '@/components/exchangeRecord';
import guessOrder from '@/components/guessOrder';
import guessOrderDetail from '@/components/guessOrderDetail';
import guessDetail from '@/components/guessDetail';
import guessRule from '@/components/guessRule';
import lotteryIndex from '@/components/lotteryIndex';
import task from '@/components/task';
import taskRule from '@/components/taskRule';
import test from '@/components/Test';


Vue.use(Router);

var dist = {
  'gb':{
    'guessList':'竞猜列表',
    'guessDetail':'比赛内页',
    'message': '通知',
    'mall': '商城',
    'exchange': '兑换记录',
    'guessOrder':'竞猜订单',
    'guessOrderDetail':'订单详情',
    'guessRule':'竞猜规则',
    'lottery': '抽奖',
    'task':'任务',
    'taskRule':'任务说明'
  },
  'en':{
    'guessList':'7M Guess',
    'guessDetail':'比赛内页',
    'message': 'My Notification',
    'mall': 'Shop',
    'exchange': 'Exchange Record',
    'guessOrder':'Guess Orders',
    'guessOrderDetail':'Order Details',
    'guessRule':'Guess Rules',
    'lottery': 'Lucky Draw',
    'task':'Task',
    'taskRule':'Task Introduction'
  },
  'kr':{
    'guessList':'7M 퀴즈 게임',
    'guessDetail':'比赛内页',
    'message': '알림',
    'mall': '쇼핑몰',
    'exchange': '교환 내역',
    'guessOrder':'퀴즈 내역',
    'guessOrderDetail':'주문 내역',
    'guessRule':'퀴즈 규칙',
    'lottery': '추첨',
    'task':'미션',
    'taskRule':'미션 설명'
  },
  'th':{
    'guessList':'7M ทาย',
    'guessDetail':'比赛内页',
    'message': 'การแจ้งเตือน',
    'mall': 'ร้านค้า',
    'exchange': 'บันทึกการแลกเปลี่ยน',
    'guessOrder':'บิลของเกมทาย',
    'guessOrderDetail':'รายละเอียดของบิล',
    'guessRule':'กฎกติกาของเกมทาย',
    'lottery': 'หมุนรางวัล',
    'task':'กิจกรรม',
    'taskRule':'คำชี้แจงของกิจกรรม'
  },
  'vn':{
    'guessList':'Dự đoán 7M',
    'guessDetail':'比赛内页',
    'message': 'Thông báo',
    'mall': 'Cửa hàng',
    'exchange': 'Lịch sử đổi quà',
    'guessOrder':'Đơn hàng dự đoán',
    'guessOrderDetail':'Chi tiết đơn hàng',
    'guessRule':'Quy tắc dự đoán',
    'lottery': 'Rút Thưởng',
    'task':'Nhiệm vụ',
    'taskRule':'Giới thiệu về nhiệm vụ'
  },
}
var curLang = (function(){
      if(location.hostname.indexOf('7msport') > -1)
        return 'en';
      else if(location.hostname.indexOf('7mkr') > -1)
        return 'kr';
      else if(location.hostname.indexOf('7mth') > -1)
        return 'th';
      else if(location.hostname.indexOf('7mvn') > -1)
        return 'vn';
      else if(location.hostname.indexOf('-id.7msport') > -1)
        return 'en';
      else
        return 'gb';
    })();

export default new Router({
  mode:'history',
  base:'/',
  routes: [
    {
      path: '/',
      redirect: '/index.html'
    },
    {
      path: '/index.html',
      meta: {
       title: dist[curLang].guessList,//标题
       isBack:false,
      },
      name: 'List',
      component: guessList
    },
    {
        path: '/guessDetail',
        meta: {
            keepAlive:false,
            title: dist[curLang].guessDetail,
        },
        name: 'guessDetail',
        component: guessDetail,
    },
    {
        path: '/mall',
        meta: {
            keepAlive:false,
            title: dist[curLang].mall,
        },
        name: 'Mall',
        component: mallIndex,
    },
    {
      path: '/message',
      meta: {
          keepAlive:false,
          title: dist[curLang].message,
      },
      name: 'Message',
      component: messageList,
    },
    {
      path: '/exchange',
      meta: {
          keepAlive:false,
          title: dist[curLang].exchange,
      },
      name: 'Exchange',
      component: exchangeRecord,
    },
    {

      path: '/guessOrder',
      meta: {
          keepAlive:false,
          title: dist[curLang].guessOrder,
      },
      name: 'guessOrder',
      component: guessOrder,
    },
    {
      path: '/guessOrderDetail',
      meta: {
          keepAlive:false,
          title: dist[curLang].guessOrderDetail,
      },
      name: 'guessOrderDetail',
      component: guessOrderDetail,
    },
    {

      path: '/guessRule',
      meta: {
          keepAlive:false,
          title: dist[curLang].guessRule,
      },
      name: 'guessRule',
      component: guessRule,
    },
    {
      path: '/lottery',
      meta: {
          keepAlive:false,
          title: dist[curLang].lottery,
      },
      name: 'Lottery',
      component: lotteryIndex,
    },
    {
      path: '/task',
      meta: {
          keepAlive:false,
          title: dist[curLang].task,
      },
      name: 'task',
      component: task,
    },
    {
      path: '/taskRule',
      meta: {
          keepAlive:false,
          title: dist[curLang].taskRule,
      },
      name: 'taskRule',
      component: taskRule,
    },
    {
      path: '/test',
      name: 'Test',
      component: test
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js